import React from "react";
import SubmittedCopyright from "../sumitted_copyright/SubmittedCopyright";
import { useAuthorized } from "../../../../hooks/useAuthorized";
import Loader from "../../../../components/custom/Loader";
import { accessRoles } from "../../../../utils/accessRoles";

const HearingScheduleCopyright = () => {
  const { hasRole, isLoading } = useAuthorized();
  if (isLoading) {
    return <Loader />;
  }
  const pageTitle = hasRole([
    accessRoles.Examiner,
    accessRoles.AssistantExaminer,
    accessRoles.Indexer,
  ])
    ? "শুনানী গ্রহনের নথি"
    : "চিঠিসহ শুনানী গ্রহনের নথি";

  const fileStatus = 23;
  const applicationPath = {
    copyright: "/admin/hearing-schedule-copyright",
    agreement: "/admin/hearing-schedule-agreement",
  };
  const detailsRoute = hasRole([
    accessRoles.Examiner,
    accessRoles.AssistantExaminer,
    accessRoles.Indexer,
  ])
    ? "/admin/hearing-schedule-copyright-details"
    : "/admin/submitted-copyright-details-verify";
  return (
    <SubmittedCopyright
      fileStatus={fileStatus}
      applicationPath={applicationPath}
      detailsRoute={detailsRoute}
      pageTitle={pageTitle}
    />
  );
};

export default HearingScheduleCopyright;
